(function () {
  angular
    .module("akitabox.ui.dialogs.ocr", [
      "ngMaterial",
      "akitabox.core.services.document",
      "akitabox.core.services.user",
      "akitabox.core.toast",
    ])
    .controller("OcrDialogController", OcrDialogController);

  /* @ngInject */
  function OcrDialogController(
    // Angular
    $scope,
    $q,
    // Material
    $mdDialog,
    // Services
    DocumentService,
    ToastService,
    UserService
  ) {
    var self = this;

    // Constants
    var MAX_FILE_SIZE_BYTES = 1000 * 1000 * 10; // 10MB
    var OCR_CONTENT_ID = "ocr-content";
    var OCR_HIGHLIGHT_CONTAINER_CLASS = "ocr-highlight-container";
    var ABX_DESCRIPTION_ATTR = "abx-description";
    var OCR_HIGHLIGHT_CLASS = "ocr-highlight-box";
    var OCR_HIGHLIGHT_CLASS_ON = OCR_HIGHLIGHT_CLASS + "--on";
    var ORIENTATION_ROTATION = {
      1: 0,
      2: 0, // Flip across y-axis
      3: 180,
      4: 180, // Rotate 180 and flip across y-axis
      5: 90, // Rotate 90 and flip across y-axis
      6: 90,
      7: 270, // Rotate 270 and flip across y-axis
      8: 270,
    };
    var ANNOTATION_SHIFTS = [
      [0, 0], // 0. Center
      [1, 1], // 1. Top-right
      [1, 0], // 2. Right
      [1, -1], // 3. Bottom-right
      [0, -1], // 4. Bottom
      [-1, -1], // 5. Bottom-left
      [-1, 0], // 6. Left
      [-1, 1], // 7. Top-Left
      [0, 1], // 8. Top
    ];
    var ORIENTATION_SHIFT = {
      3: 0,
      4: 0,
      5: 5,
      6: 5,
      7: 5,
      8: 5,
    };

    // Private Attributes
    var highlightBoxes = [];
    var $highlightContainer;
    var fileTooBig = self.document.size > MAX_FILE_SIZE_BYTES;
    var hasAnnotationPresets = false;
    // var _permissions = UserService.getPermissions();

    // Attributes
    self.selectedText = null;
    self.showControls = false;
    self.loading = true;
    self.ocrDisabled = true;
    self.annotationShift = 0;
    self.imageDimensions = null;
    self.imageOrientation = 0;
    self.imageRotation = 0;
    self.orientRotation = 0; // 90, 180, 270
    self.highlightRotation = 0;
    self.highlightShiftX = 0;
    self.highlightShiftY = 0;
    self.autoAlignAnnotations = true;

    // Functions
    self.cancel = $mdDialog.cancel;
    self.getOcrData = getOcrData;
    self.addAnnotations = addAnnotations;
    self.onRotate = onRotate;
    self.toggleHighlightBoxes = toggleHighlightBoxes;
    self.reload = reload;
    self.shiftAnnotations = shiftAnnotations;
    self.rotateAnnotations = rotateAnnotations;
    self.resetAnnotations = resetAnnotations;
    self.onAutoAlignChanged = onAutoAlignChanged;
    self.saveAnnotationSettings = saveAnnotationSettings;

    // Get Ocr data when <ocr-content></ocr-content> is on the DOM
    $scope.$watch(document.getElementById(OCR_CONTENT_ID), getOcrData);

    // =================
    // Public Functions
    // =================

    /**
     * Retrieve OCR data to display on the image
     */
    function getOcrData() {
      if (fileTooBig) {
        ToastService.showError("File is too big, maximum file size is 10MB");
        self.loading = false;
        return $q.reject();
      }
      return DocumentService.getOcrById(
        self.document.building,
        self.document._id
      )
        .then(function (_document) {
          self.document = _document;
          var ocrData = self.document.ocr;
          if (!ocrData || !ocrData.textAnnotations) {
            return $q.reject("No text annotations found");
          }
          self.ocrDisabled = false;

          var customAnnotationRotation = self.document.ocr_annotation_rotation;
          var customAnnotationShiftX = self.document.ocr_annotation_shift_x;
          var customAnnotationShiftY = self.document.ocr_annotation_shift_y;

          hasAnnotationPresets =
            customAnnotationRotation ||
            customAnnotationShiftX >= -1 ||
            customAnnotationShiftY >= -1;
        })
        .catch(ToastService.showError)
        .finally(function () {
          self.loading = false;
        });
    }

    /**
     * Reload OCR data
     */
    function reload() {
      self.loading = true;
      self.showControls = false;
      self.selectedText = null;
      self.resetAnnotations();
      if ($highlightContainer) {
        $highlightContainer.css("display", "none");
      }
      self.highlightRotation = 0;
      getOcrData().then(function () {
        if ($highlightContainer) {
          $highlightContainer.css("display", "block");
        }
      });
    }

    /**
     * Toggle green highlight boxes on/off.
     */
    function toggleHighlightBoxes() {
      highlightBoxes = highlightBoxes.map(function (el) {
        el.classList.toggle(OCR_HIGHLIGHT_CLASS_ON);
        return el;
      });
    }

    function shiftAnnotations(shift) {
      self.autoAlignAnnotations = false;
      _shiftAnnotations(shift);
    }

    /**
     * Create text highlight boxes and add them to the DOM
     *
     * @param {Object}  Event {dimensions, rotation, orientation}
     */
    function addAnnotations($event) {
      // Add highlight container
      var ocrContent = document.getElementById(OCR_CONTENT_ID);
      var highlightContainer = document.createElement("div");
      highlightContainer.setAttribute("class", OCR_HIGHLIGHT_CONTAINER_CLASS);
      $highlightContainer = angular.element(highlightContainer);

      var ocrData = self.document.ocr;
      var text = ocrData ? ocrData.textAnnotations : null;

      if (!text || !ocrContent || !$highlightContainer) {
        return;
      }

      var dimensions = $event.dimensions;

      self.imageOrientation = $event.orientation;
      self.imageRotation = $event.rotation;
      self.orientRotation = ORIENTATION_ROTATION[self.imageOrientation];
      self.imageDimensions = dimensions;

      var imageWidth = dimensions.width;
      var imageHeight = dimensions.height;

      for (var i = 1; i < text.length; i++) {
        var data = text[i];
        var vertices = data.boundingPoly.vertices;
        var el = document.createElement("div");
        var top = vertices[1].y;
        var right = vertices[2].x;
        var bottom = vertices[3].y;
        var left = vertices[0].x;

        for (var j = 0; j < 4; ++j) {
          var v = vertices[j];
          if (v.y < top) {
            top = v.y;
          }
          if (v.x > right) {
            right = v.x;
          }
          if (v.y > bottom) {
            bottom = v.y;
          }
          if (v.x < left) {
            left = v.x;
          }
        }

        // Styles
        el.style.left = left + "px";
        el.style.top = top + "px";
        el.style.width = right - left + "px";
        el.style.height = bottom - top + "px";
        el.classList.add(OCR_HIGHLIGHT_CLASS, OCR_HIGHLIGHT_CLASS_ON);

        // Attributes
        el.setAttribute("id", "ocr-box-id-" + i);
        el.setAttribute(ABX_DESCRIPTION_ATTR, data.description);

        el.onclick = onBoxClick;
        el.onmouseover = onBoxMouseover;

        highlightBoxes.push(el);
        highlightContainer.appendChild(el);
      }

      if ($highlightContainer) {
        $highlightContainer.css({
          position: "fixed",
          top: 0,
          left: 0,
          width: imageWidth,
          height: imageHeight,
        });
      }

      if (hasAnnotationPresets) {
        _applyAnnotationPresets();
      } else if (self.autoAlignAnnotations) {
        _alignAnnotations();
      }

      ocrContent.appendChild(highlightContainer);

      $scope.$apply(function () {
        self.showControls = true;
      });
    }

    /**
     * Handle image rotated
     *
     * @param {Object}  Event {dimensions, rotation}
     */
    function onRotate($event) {
      var rotation = $event.rotation;
      var change = rotation - self.imageRotation !== 0 ? 90 : 0;
      self.imageRotation = rotation;
      if (change) {
        rotateHighlightBoxes(self.highlightRotation + change);
      }
    }

    function rotateAnnotations() {
      rotateHighlightBoxes(self.highlightRotation + 90);
    }

    function resetAnnotations() {
      self.autoAlignAnnotations = false;
      _resetAnnotations();
    }

    function onAutoAlignChanged() {
      _resetAnnotations();
      if (self.autoAlignAnnotations) {
        _alignAnnotations();
      }
    }

    function saveAnnotationSettings() {
      // TODO: update document, requires permission group changes
    }

    // =================
    // Private Functions
    // =================

    /**
     * Copy a value to clipboard by creating
     * a dummy textarea
     *
     * @param {String} value - value to be copied
     */
    function copyToClipboard(value) {
      var el = document.createElement("textarea");
      el.value = value;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      ToastService.showSimple("Copied to Clipboard");
    }

    function _applyAnnotationPresets() {
      var customRotation = self.document.ocr_annotation_rotation;
      var customShiftX = self.document.ocr_annotation_shift_x;
      var customShiftY = self.document.ocr_annotation_shift_y;
      rotateHighlightBoxes(customRotation);
      for (var shift = 0; shift < ANNOTATION_SHIFTS.length; ++shift) {
        var coords = ANNOTATION_SHIFTS[shift];
        var x = coords[0];
        var y = coords[1];
        if (customShiftX === x && customShiftY === y) {
          _shiftAnnotations(shift);
          break;
        }
      }
    }

    function _resetAnnotations() {
      _shiftAnnotations(0);
      rotateHighlightBoxes(0);
    }

    function _shiftAnnotations(shift) {
      if (shift === null || shift === undefined) {
        shift = self.annotationShift + 1;
      }
      if (shift === ANNOTATION_SHIFTS.length) {
        shift = 0;
      }
      if (self.annotationShift > 0) {
        // undo previous shift
        var currentShiftCoords = ANNOTATION_SHIFTS[self.annotationShift];
        var x = currentShiftCoords[0];
        var y = currentShiftCoords[1];
        if (x > 0) {
          x = -1;
        } else if (x < 0) {
          x = 1;
        }
        if (y > 0) {
          y = -1;
        } else if (y < 0) {
          y = 1;
        }
        shiftHighlightBoxes(self.imageDimensions, x, y);
      }
      // apply new shift
      self.annotationShift = shift;
      var shiftCoords = ANNOTATION_SHIFTS[shift];
      shiftHighlightBoxes(self.imageDimensions, shiftCoords[0], shiftCoords[1]);
      // update metadata
      var shiftX = shiftCoords[0];
      var shiftY = shiftCoords[1];
      self.highlightShiftX = shiftX > 0 ? "+1" : shiftX;
      self.highlightShiftY = shiftY > 0 ? "+1" : shiftY;
    }

    function _alignAnnotations() {
      if (self.orientRotation) {
        rotateHighlightBoxes(self.orientRotation);
      }

      if (self.imageRotation) {
        var annotationRotation = self.orientRotation + self.imageRotation;
        if (annotationRotation >= 360) {
          annotationRotation -= 360;
        }
        rotateHighlightBoxes(annotationRotation);
      }

      var annotationShift = ORIENTATION_SHIFT[self.imageOrientation] || 0;
      if (annotationShift > 0) {
        _shiftAnnotations(annotationShift);
      }
    }

    /**
     * Shift highlight boxes a distance (pixels) equal to the
     * difference between the image height and width (divided by 2)
     *
     * @param {Object} dimensions   Image dimensions (width, height, etc)
     * @param {Number} x            Shift box right/left (1/-1)
     * @param {Number} y            Shift box up/down (1/-1)
     */
    function shiftHighlightBoxes(dimensions, x, y) {
      var width = dimensions.width;
      var height = dimensions.height;
      var difference = Math.abs(width - height) / 2;

      var shifts = [];

      if (x > 0) {
        shifts.push(shiftRight);
      } else if (x < 0) {
        shifts.push(shiftLeft);
      }

      if (y > 0) {
        shifts.push(shiftUp);
      } else if (y < 0) {
        shifts.push(shiftDown);
      }

      if (shifts.length) {
        for (var i = 0; i < highlightBoxes.length; ++i) {
          var box = highlightBoxes[i];
          for (var j = 0; j < shifts.length; ++j) {
            box = shifts[j](box);
          }
          highlightBoxes[i] = box;
        }
      }

      function shiftUp(e) {
        e.style.top = parsePixels(e.style.top) - difference + "px";
        return e;
      }

      function shiftDown(e) {
        e.style.top = parsePixels(e.style.top) + difference + "px";
        return e;
      }

      function shiftLeft(e) {
        e.style.left = parsePixels(e.style.left) - difference + "px";
        return e;
      }

      function shiftRight(e) {
        e.style.left = parsePixels(e.style.left) + difference + "px";
        return e;
      }

      function parsePixels(pixels) {
        return pixels ? parseInt(pixels.replace("px", "")) : 0;
      }
    }

    function rotateHighlightBoxes(rotation) {
      self.highlightRotation = rotation;
      if (self.highlightRotation === 360) {
        self.highlightRotation = 0;
      }
      if ($highlightContainer) {
        $highlightContainer.css({
          transform: "rotate(" + self.highlightRotation + "deg)",
        });
      }
    }

    /**
     * Copy box description to clipboard
     *
     * @param {Event} $event Event
     */
    function onBoxClick($event) {
      var description = $event.target.getAttribute(ABX_DESCRIPTION_ATTR);
      copyToClipboard(description);
    }

    /**
     * Set selected text to box description
     *
     * @param {Event} $event Event
     */
    function onBoxMouseover($event) {
      $scope.$apply(function () {
        var description = $event.target.getAttribute(ABX_DESCRIPTION_ATTR);
        self.selectedText = description;
      });
    }
  }
})();
